module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAAAAACPAi4CAAAAAXNSR0IArs4c6QAAAR5JREFUWMPt1t1uhCAQhuG9/ysFkfq3VqkLbw9qXXRNAEmTbsIcknyPyTCYuYnMuhWgAP8OUE0bV406A+REfE3yFUjJw+cLIJPyOHkENGD6uDKAPgIfwD2y8+N7AnoYO3UdkAbADZeBZb29IRKo2mqX77frr6MA7bC1D3wBnZqAPgbQDlikBzhYhFC/IxwAtAVg9gALrhYdMIaBNb9r6QS4xQFtEKjt9mCaDajdevQI3oKXX1suhBCi+xGsCgF+Hh7PRurZYccqNEj7/L6RQobfwmyP/4172mM6qdafR2tHlQo8G6kMAKZJA7ZG9m47GaYUAON93qt4gPs2BhcBenNymAKcVgEK8DeAzgWyV5zsJSt/zcteNMu2XoC3Br4B0HX9BqBuSogAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/assets/images/default-img.png
// module id = 8fJy
// module chunks = 243